export const CommissionHistoryMap = {
  GET_ALL_COMMISSION_HISTORY_START: "GET_ALL_COMMISSION_HISTORY_START",
  GET_ALL_COMMISSION_HISTORY_SUCCESS: "GET_ALL_COMMISSION_HISTORY_SUCCESS",
  GET_ALL_COMMISSION_HISTORY_ERROR: "GET_ALL_COMMISSION_HISTORY_ERROR",
  APPLY_FILTERS: "APPLY_FILTERS",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  SELECT_TEXT_CHANGE: "SELECT_TEXT_CHANGE",
  REFRESH_COMMISSION_HISTORY_LIST: "REFRESH_COMMISSION_HISTORY_LIST",
  SET_COMMISSION_HISTORY_BATCH_NUMBER: "SET_COMMISSION_HISTORY_BATCH_NUMBER",
  GET_COMMISSION_HISTORY_START: "GET_COMMISSION_HISTORY_START",
  GET_COMMISSION_HISTORY_SUCCESS: "GET_COMMISSION_HISTORY_SUCCESS",
  GET_COMMISSION_HISTORY_ERROR: "GET_COMMISSION_HISTORY_ERROR",
  SET_TO_DATE_CHANGES: "SET_TO_DATE_CHANGES",
  SET_FROM_DATE_CHANGES: "SET_FROM_DATE_CHANGES",
  RESET_FILTERS: "RESET_FILTERS",
};

export const CommissionHistoryActions = {
  getAllCommissionHistoryStart: (data) => ({
    type: CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_START,
    payload: data,
  }),
  getAllCommissionHistorySuccess: (data) => ({
    type: CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_SUCCESS,
    payload: data,
  }),
  getAllCommissionHistoryError: (errors) => ({
    type: CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_ERROR,
    payload: { errors },
  }),
  getCommissionHistoryStart: (data) => ({
    type: CommissionHistoryMap.GET_COMMISSION_HISTORY_START,
    payload: data,
  }),
  getCommissionHistorySuccess: (data) => ({
    type: CommissionHistoryMap.GET_COMMISSION_HISTORY_SUCCESS,
    payload: data,
  }),
  getCommissionHistoryError: (errors) => ({
    type: CommissionHistoryMap.GET_COMMISSION_HISTORY_ERROR,
    payload: { errors },
  }),

  applyFilters: (data) => ({
    type: CommissionHistoryMap.APPLY_FILTERS,
    payload: data,
  }),
  refreshCommissionHistoryList: () => ({
    type: CommissionHistoryMap.REFRESH_COMMISSION_HISTORY_LIST,
  }),
  searchTextChange: (data) => ({
    type: CommissionHistoryMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),

  selectTextChange: (updatedFields) => ({
    type: CommissionHistoryMap.SELECT_TEXT_CHANGE,
    payload: updatedFields,
  }),

  setVirtualTokenBatchNumber: (data) => ({
    type: CommissionHistoryMap.SET_COMMISSION_HISTORY_BATCH_NUMBER,
    payload: data,
  }),

  toDateChanges: (data) => ({
    type: CommissionHistoryMap.SET_TO_DATE_CHANGES,
    payload: data,
  }),
  fromDateChanges: (data) => ({
    type: CommissionHistoryMap.SET_FROM_DATE_CHANGES,
    payload: data,
  }),
  resetFilters: (data) => ({
    type: CommissionHistoryMap.RESET_FILTERS,
    payload: data,
  }),
};
